import { FETCH_GET, FETCH_POST } from "../../config";

export const GET_SLIDERS_PENDING = "GET_SLIDERS_PENDING";
export const GET_SLIDERS_FULFILLED = "GET_SLIDERS_FULFILLED";
export const GET_SLIDERS_REJECTED = "GET_SLIDERS_REJECTED";

export const FETCH_ACTIVE_SLIDERS_PENDING = "FETCH_ACTIVE_SLIDERS_PENDING";
export const FETCH_ACTIVE_SLIDERS_FULFILLED = "FETCH_ACTIVE_SLIDERS_FULFILLED";
export const FETCH_ACTIVE_SLIDERS_REJECTED = "FETCH_ACTIVE_SLIDERS_REJECTED";

export const SLIDER_COLLECTION_PENDING = "SLIDER_COLLECTION_PENDING";
export const SLIDER_COLLECTION_FULFILLED = "SLIDER_COLLECTION_FULFILLED";
export const SLIDER_COLLECTION_REJECTED = "SLIDER_COLLECTION_REJECTED";

export const getAllSliders = () => {
  const query = `query={getAllSliders{id,image,title{text,color},content{text,color},link{text,color,bg,url}}}`;
  return async (dispatch) => {
    dispatch({ type: GET_SLIDERS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: GET_SLIDERS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: GET_SLIDERS_FULFILLED,
          payload: result.data.data.getAllSliders,
        });
      }
    } catch (e) {
      dispatch({ type: GET_SLIDERS_REJECTED, payload: e });
    }
  };
};

export const getActiveSliders = () => {
  const query = `query={getActiveSliders{id,image,title{text,color},content{text,color},link{text,color,bg,url},products{id},slug,collectionTitle,active,order}}`;
  return async (dispatch) => {
    dispatch({ type: FETCH_ACTIVE_SLIDERS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: FETCH_ACTIVE_SLIDERS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_ACTIVE_SLIDERS_FULFILLED,
          payload: result.data.data.getActiveSliders,
        });
      }
    } catch (e) {
      dispatch({ type: FETCH_ACTIVE_SLIDERS_REJECTED, payload: e });
    }
  };
};

// Slider'a bağlı ürünleri (kategori/marka ile) getirir — /slider/:id sayfası için
export const getSliderWithProducts = (id) => {
  const query = `query($id:ID!){getSliderById(id:$id){id,title{text,color},content{text,color},image,collectionTitle,slug,products{id,name,
    content,
    categories{id,title,slug,discount{percent,price}},
    brand{id,name,slug,active},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url},
    isBestSeller,
    isDeal,
    dealEndDate,
    dealOrder,
    viewCount,
    isNewProduct,
    newUntilDate,
    lowStockThreshold}}}`;
  const variables = JSON.stringify({ id });
  return async (dispatch) => {
    dispatch({ type: SLIDER_COLLECTION_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });
      if (result.data.errors) {
        dispatch({
          type: SLIDER_COLLECTION_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: SLIDER_COLLECTION_FULFILLED,
          payload: result.data.data.getSliderById,
        });
      }
    } catch (e) {
      dispatch({ type: SLIDER_COLLECTION_REJECTED, payload: e });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/slider.js